module.exports = __webpack_public_path__ + "img/fot_logo_03.80710c5b.png";